import { Component, EventEmitter, Output } from '@angular/core';
import { ButtonsModule, CardModule, ChipsModule, IconModule } from '@mastechnicaegroup/carelinelive-ui';
import { markerSvg } from '../../../../../assets/markers.svg';

@Component({
    selector: 'app-package-map-key',
    imports: [
        ChipsModule,
        IconModule,
        CardModule,
        ButtonsModule
    ],
    templateUrl: './package-map-key.component.html',
    standalone: true,
    styleUrl: './package-map-key.component.scss'
})
export class PackageMapKeyComponent {

    @Output() remove = new EventEmitter();

    protected readonly icons = [
        {
            key: 'icon1',
            svg: markerSvg.makeBtoa('open', '', 'Single Open Package Marker', 0.65),
            text: 'Open packages'
        },
        {
            key: 'icon2',
            svg: markerSvg.makeBtoa('closed', '', 'Single Closed Package Marker', 0.65),
            text: 'Closed packages'
        },
        {
            key: 'icon3',
            svg: markerSvg.makeBtoa('mixed', '', 'Mixed Packages Marker', 0.65),
            text: 'Cluster of packages of mixed status'
        }
    ];
}
